<template>
    <div>
        <el-row :gutter="20" class="contact-list-index-page pt-3">
            <el-col :span="12">
                <div class="border border-gray-500 contact-list-container">
                    <div class="py-2 bg-gray-500 text-center header">
                        <h5 class="mb-0">CONTACT LISTS</h5>
                    </div>
                    <contact-list-list
                            v-bind="contactListList"
                            ref="contactListList"
                    ></contact-list-list>
                </div>

            </el-col>
            <el-col :span="12">
                <div class="border border-gray-500 contact-list-container">
                    <div class="py-2 bg-gray-500 text-center header">
                        <h5 class="mb-0">CONTACTS</h5>
                    </div>
                    <contact-list
                            :key="contactListKey"
                            v-if="isContactListSelected"
                            :contact-list="currentContactList"
                            v-bind="contactList"
                    ></contact-list>
                </div>
            </el-col>
        </el-row>
        <contact-list-form-wrapper></contact-list-form-wrapper>
        <contact-form-wrapper></contact-form-wrapper>
    </div>
</template>

<script>
  import ContactListList from './contact_list-list/list-wrapper';
  import ContactList from './contact-list/list-wrapper';
  import ContactListFormWrapper from './dialog-contact-list-form-wrapper';
  import ContactFormWrapper from './dialog-contact-form-wrapper';
  import eventBus from "../../event-bus";

  export default {
    components: {
      ContactListList,
      ContactList,
      ContactListFormWrapper,
      ContactFormWrapper,
    },

    props: {
      contactListList: Object,
      contactList: Object,
    },

    data() {
      return {
        currentContactList: null,
      };
    },

    computed: {
      /**
       * @return {boolean}
       */
      isContactListSelected() {
        return Boolean(this.currentContactList);
      },

      /**
       * @return {string}
       */
      contactListKey() {
        return this.getNewKey(_.get(this.currentContactList, 'model.id', '') + '_');
      },
    },

    methods: {
      /**
       * @param {object|null} item
       */
      onContactListCurrentChange(item) {
        this.currentContactList = item;
      },

      /**
       * @param {string} prefix
       * @return {string}
       */
      getNewKey(prefix = '') {
        return prefix + moment().format('x');
      },

      /**
       * @return {undefined}
       */
      onRefreshContactListList() {
        this.$refs.contactListList.refreshList();
      },
    },

    created() {
      eventBus.$on('contact-list-current-change', this.onContactListCurrentChange);
      eventBus.$on('refresh-contact-list-list', this.onRefreshContactListList);
    },

    beforeDestroy() {
      eventBus.$off('contact-list-current-change', this.onContactListCurrentChange);
      eventBus.$off('refresh-contact-list-list', this.onRefreshContactListList);
    }
  }
</script>
